import axios from "axios";
import { ElNotification } from "element-plus";
import { Root } from "protobufjs";
import adapterRequest from "axios/lib/adapters/xhr";

import pb from "@pb/index.json";

import Logger from "@js/logger";
import Error from "@js/error";
import DYLongLinkClient from "@js/web/socket/websocket";
import { baseURL, clientHeader } from "@/config";
import { clear, getLoginKey } from "@js/account/index";
import { INamespace } from "protobufjs";

const root = Root.fromJSON(pb as INamespace);

const PBJSONROOT = pb.nested.yunpb.nested;
const PBOPERATIONTYPE = PBJSONROOT.OperationType.values;

// 请求设置
const Axios = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  responseType: "arraybuffer",
  headers: {
    "Content-Type": "application/protobuf",
  },
});

// Add a request interceptor
Axios.interceptors.request.use(
  (config: any) => {
    // Do something before request is sent
    return config;
  },
  (err: any) => {
    // Do something with request error
    return Promise.reject(err.data.error.message);
  }
);

Axios.interceptors.response.use(
  (res: any) => {
    // Do something with response data
    return res;
  },
  (err: any) => {
    // Do something with response error
    return Promise.reject(err);
  }
);

export default (settings: {
  showNotification?: boolean;
  notificationText?: string;
  reqDesction: string;
  resDesction: string;
  serverName: string;
  funcName: string;
  data: any;
  useSocket?: boolean;
  op?: number;
}): Promise<any> => {
  if (!settings.data) settings.data = {};
  if (
    settings.useSocket &&
    DYLongLinkClient.getInstance().isConnectionReady()
  ) {
    if (!settings.op) {
      settings.op = PBOPERATIONTYPE.OP_SEND_SMS;
    }

    return DYLongLinkClient.getInstance().sendRequest(settings);
  }
  const defaults = {
    showNotification: true,
    url: "/proxyyun",
    method: "post",
    rpcInDesction: "RPCInput",
    rpcOutDesction: "RPCOutput",
  };
  const opts = Object.assign(defaults, settings);
  console.log("opts", opts);
  const reqBuffer = encode(opts.reqDesction, opts.data);
  const rpcBuffer = encode(opts.rpcInDesction, {
    obj: opts.serverName,
    func: opts.funcName,
    req: reqBuffer,
    opt: {
      "X-Token": getLoginKey(),
      client: clientHeader,
    },
  });
  return new Promise((resolve, reject) => {
    Axios[opts.method](opts.url, rpcBuffer, {
      adapter: xhrAdapter,
      rpcBuffer,
      headers: {
        "X-Token": getLoginKey(),
        client: clientHeader,
        language: localStorage.getItem("lang") || "en",
      },
    })
      .then((res: any) => {
        if (res.status !== 200 && opts.showNotification) {
          // ElNotification("warning", {
          //   message:
          //     opts.notificationText ||
          //     Error.clientErrorMessage(Error.CONST.clientError),
          //   description: res.data.message,
          // });
        } else {
          const rpcOut = decode(opts.rpcOutDesction, new Uint8Array(res.data));
          if (rpcOut && rpcOut.ret === 0) {
            res.data = rpcOut.rsp ? decode(opts.resDesction, rpcOut.rsp) : {};
            resolve(res.data);
          } else {
            // 登录失效
            if (Error.shouldClearAccounts(rpcOut.ret)) {
              clear();
            } else {
              // opts.showNotification &&
              // ElNotification("warning", {
              //     message: opts.notificationText || Error.errorMessage(rpcOut),
              //     description: rpcOut.desc,
              //   });
            }

            Logger.error(
              `request rpcoutput error ${opts.funcName} ${rpcOut.ret} ${rpcOut.desc}`
            );
            reject(rpcOut);
          }
        }
      })
      .catch((err: any) => {
        // opts.showNotification &&
        //   OpenNotification('error', {
        //     description: err.message,
        //     message: opts.notificationText || Error.clientErrorMessage(Error.CONST.clientError),
        //   });
        reject(err);
        console.log("请求报错", err);

        Logger.error(`request exception ${settings.funcName} ${err.message}`);
      });
  });
};

// 生成消息体
const encode = (desction: string, data: any): any => {
  console.log("desction6666666666:", desction);
  const dataDesction = root.lookupType(desction);
  console.log("dataDesction666666:", dataDesction);
  const err = dataDesction.verify(data);

  if (err) {
    return false;
  } else {
    const message = dataDesction.create(data);
    const buffer = dataDesction.encode(message).finish();
    return buffer;
  }
};

// 解析响应体
export const decode = (desction: string, data: any): any => {
  const dataDesction = root.lookupType(desction);
  const err = dataDesction.verify(data);

  if (err) {
    return false;
  } else {
    const res = dataDesction.decode(data);
    const result = dataDesction.toObject(res, {
      defaults: true,
    });
    return result;
  }
};

const xhrAdapter = (config: any) => {
  config.data = config.rpcBuffer;
  return adapterRequest(config);
};
